module.exports = "https://r.nearpod.com/assets/media/image/audio-player-line-d5fa95bb60fc6d02078643f21f5adf08.svg";